import { render, staticRenderFns } from "./Props.vue?vue&type=template&id=2b751829&"
import script from "./Props.vue?vue&type=script&lang=js&"
export * from "./Props.vue?vue&type=script&lang=js&"
import style0 from "./Props.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports